
// If this file doesn't exist yet, we need to create it with proper typing
import { supabase } from "@/integrations/supabase/client";
import { Notification } from "@/hooks/useNotificationDetail";
import { SupabaseNotification } from "@/types/notifications";

export const updateNotificationInDb = async (
  id: string,
  notification: SupabaseNotification | Notification,
  updates: Partial<SupabaseNotification | Notification>,
  editor_id?: string, 
  editor_name?: string
) => {
  console.log("updateNotificationInDb - Starting update for id:", id);
  console.log("updateNotificationInDb - Updates to apply:", updates);
  
  if (!id) {
    const error = new Error("Notification ID is required");
    console.error(error);
    throw error;
  }

  // Make sure we're not sending undefined values to Supabase
  const cleanUpdates: Record<string, any> = {};
  
  for (const [key, value] of Object.entries(updates)) {
    // Skip any properties that are undefined
    if (value !== undefined) {
      cleanUpdates[key] = value;
    }
  }
  
  // Always include updated_at timestamp
  cleanUpdates.updated_at = new Date().toISOString();
  
  console.log("updateNotificationInDb - Clean updates to send:", cleanUpdates);

  try {
    // Update the notification
    const { data, error } = await supabase
      .from('notifications')
      .update(cleanUpdates)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error("Supabase update error:", error);
      throw error;
    }
    
    console.log("updateNotificationInDb - Updated data:", data);
    
    // If editor info is provided, record the edit history
    if (editor_id && editor_name) {
      try {
        // Create edit history entry for each changed field
        for (const [key, value] of Object.entries(cleanUpdates)) {
          if (key !== 'updated_at') { // Skip the updated_at timestamp
            const previousValue = notification[key as keyof typeof notification];
            
            // Only create history if the value has changed
            if (String(previousValue) !== String(value)) {
              await supabase
                .from('notification_edit_history')
                .insert({
                  notification_id: id,
                  editor_id,
                  editor_name,
                  field_name: key,
                  previous_value: typeof previousValue === 'object' ? JSON.stringify(previousValue) : String(previousValue),
                  new_value: typeof value === 'object' ? JSON.stringify(value) : String(value),
                  change_type: 'field_update',
                  // For message field, store the full message text
                  previous_message: key === 'message' ? String(previousValue) : null,
                  new_message: key === 'message' ? String(value) : null
                });
            }
          }
        }
      } catch (historyError) {
        console.error("Error recording edit history:", historyError);
        // Don't fail the whole operation if just the history logging fails
      }
    }
    
    // Return the updated notification data
    return data || notification;
  } catch (error) {
    console.error("Error in updateNotificationInDb:", error);
    throw error;
  }
};
